import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Form, FormGroup, FormLabel, FormControl, Alert, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { login } from "../../actions/userActions";
import { userLoginReset } from '../../reducers/userReducers';
import { Turnstile } from '@marsidev/react-turnstile'
import { COLORS } from '../../constants/colors';

const Login = () => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)
    const [turnstileToken, setTurnstileToken] = useState(null)

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const {
        userReducers: { userInfo, error: loginError }
    } = useSelector((state) => state)

    React.useEffect(() => {
        if(userInfo){
            navigate('/profile')
            dispatch(userLoginReset())
        }
    }, [navigate, userInfo, dispatch])

    React.useEffect(() => {
        if (loginError) {
            setError(loginError)
        }
    }, [loginError])

    const submitHandler = async (e) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);

        try {
            if (!turnstileToken) {
                throw new Error('Security check failed. Please try again.');
            }

            await dispatch(login(email, password, turnstileToken));
        } catch (err) {
            console.error('Login error:', err);
            setError(err.message || 'An error occurred during login');
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div className="login-container">
            <h2 className="text-center mb-4">Sign In</h2>
            
            {error && (
                <Alert variant="danger" onClose={() => setError(null)} dismissible>
                    {error}
                </Alert>
            )}

            <Form onSubmit={submitHandler}>
                <FormGroup controlId='email'>
                    <FormLabel className='my-2 fw-semibold'>Email Address</FormLabel>
                    <FormControl
                        type='email'
                        placeholder='Enter Email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={isLoading}
                    />
                </FormGroup>

                <FormGroup controlId='password'>
                    <FormLabel className='my-2 fw-semibold'>Password</FormLabel>
                    <FormControl
                        type='password'
                        placeholder='Enter Password'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        disabled={isLoading}
                    />
                </FormGroup>

                <div className="d-flex justify-content-center my-3">
                    <Turnstile
                        siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
                        onSuccess={(token) => setTurnstileToken(token)}
                        onError={() => {
                            setError('Security check failed. Please try again.');
                            setTurnstileToken(null);
                        }}
                    />
                </div>

                <Button
                    type='submit'
                    style={{ backgroundColor: COLORS.SAGE_GREEN, borderColor: COLORS.WARM_CONCRETE }}
                    className='my-2 w-100'
                    disabled={isLoading || !turnstileToken}
                >
                    {isLoading ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            {' '}Signing in...
                        </>
                    ) : (
                        'Sign In'
                    )}
                </Button>
            </Form>
        </div>
    )
}

export default Login;
